import useSWR from 'swr';
import type { SwrReturnType } from '~/models/Api';
import type { DealSurvey } from '~/models/Survey';

const paths = {
  index: '/deals/:deal_id/deal_surveys'
};

type TIndex = (id: number | null) => SwrReturnType<DealSurvey[]>;
type ReturnType = {
  index: TIndex;
};

export const useDealSurveys = (): ReturnType => {
  const index: TIndex = (dealId: number | null) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data, mutate, error } = useSWR<DealSurvey[]>(
      dealId === null ? null : paths.index.replace(':deal_id', String(dealId))
    );
    return {
      data: data ?? null,
      mutate,
      isLoading: !data && !error,
      error
    };
  };
  return { index };
};
